import axios from 'axios'
import React, { memo, useContext, useEffect, useRef, useState } from 'react'
import { NavLink } from 'react-router-dom'
import NotificationContext from '../components/toasts/NotificationContext'
import { constants } from '../constants'
import EmailModal from '../home/components/EmailModal'
import routes from '../routers/helpers/routes'

const Login = memo(({admin}) => {

  const [nameForm, setNameForm] = useState(true)
  const {showNotification} = useContext(NotificationContext);
  const [authAdmin, setAuthAdmin] = useState(admin);
  const [code, setCode] = useState(false);
  const [sending, setSending] = useState(false);

  const inputCodeRef = useRef();

  const [login, setLogin]= useState({username: '', password: ''})
  const handleLogin = (e) => {
    e.preventDefault();
    setLogin({
      ...login,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async () => {
      if (nameForm) {
        const URL = authAdmin ? constants.test_host + '/admin/login' : constants.test_host + '/user/login';
        await axios.post(URL, {username: login.username, password: login.password, code: login.verification}, {withCredentials: true}, {headers: {
          'Content-Type': 'application/json'
        }})
        .then((resp)=>{
          window.localStorage.setItem('at', resp.data.access_token);
          if(resp.data.result){
            showNotification('success', 'Inicio de sesión exitoso');
            setTimeout(() => {
              window.location.href = '/dashboard/user';
            }, 1000);
          }
        })
        .catch((error) => {
          showNotification('failed', error.response.data.message);
        });
        
      }
      else if(!nameForm){
        //restaura contraseña
        if(login.username ==="") return showNotification('failed', 'El campo de email no puede estar vacío.')
        setSending(true)
        const URL_RESET = constants.test_host + '/mail/reset-password'
        await axios.post(URL_RESET, {email: login.username}, {withCredentials: true}, {headers: {
          'Content-Type': 'application/json'
        }})
        .then(({data})=> {
          showNotification('success', data.message);
          login.username = "";
          setSending(false);
          return
        })
        .catch((err) => {
          console.log(err)
          showNotification('failed', 'No se pudo restablecer la constraseña.')
          setSending(false);
        })
      }      
    }

    const get2FA = async() => {
      if(login.username ==="" || login.password===""){
        showNotification('failed', 'Ingrese los datos completos.');
        return
      }
      setSending(true);
      const URL = constants.test_host + '/auth/2fa';
      await axios.post(URL, {username: login.username, password: login.password}, {withCredentials: true}, {headers: {
        'Content-Type': 'application/json'
      }})
      .then(({data})=> {
        setCode(true);
        setSending(false);
        showNotification('success', data.message)
        inputCodeRef.current.focus();
      })
      .catch((error) => {
        console.log(error.response);
        setSending(false);
        showNotification('failed', error.response.data.message)

      })
      console.log('Solicitando código con ... '+ login.username);
    }

  return (
    <div className='container'>
        <div className='row justify-content-center'>
          <div className='col-lg-4'>
            <div className="card shadow-lg border-0 rounded-lg mt-2">
              <div className="card-header">
              <h5 className="text-center font-weight-light my-2">
                {nameForm ? 'Inicia Sesión' : 'Recuperar Contraseña'}
              </h5>
              </div>
            
              <div className="card-body" style={{fontSize: 'small'}}>
              <form>
                  <div className="row mb-3">
              
                    <div className="col">
                      <div className="form-floating mb-2 form-outline">
                        <input
                          className="form-control"
                          id="username"
                          type="text"
                          placeholder="Nombres"
                          name="username"
                          value={login.username}
                          onChange={handleLogin}
                          required
                        />
                        <label htmlFor="username">{nameForm? 'Email o Número de Cédula': 'Ingrese Email'}</label>
                      </div>

                      {nameForm && <div className="form-floating mb-2 form-outline">
                        <input
                          className="form-control"
                          id="password"
                          type="password"
                          placeholder="Contraseña"
                          name="password"
                          value={login.password}
                          onChange={handleLogin}
                          required
                        />
                        <label htmlFor="password">Ingrese Contraseña</label>
                      </div>}

                      {authAdmin && <div>
                        <p style={{}}>Solicite su código de verificación</p> 
                        {sending ? <button class="btn btn-primary btn-sm" type="button" disabled>
                          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                          Enviando...
                        </button>:
                        <button onClick={get2FA} className='btn btn-primary btn-sm'>Solicitar Código</button>}
                      </div>}

                      {authAdmin && code && <div className="form-floating mb-2 form-outline">
                        
                        <input
                          className="form-control"
                          id="verification"
                          type="number"
                          placeholder="ingrese código"
                          name="verification"
                          value={login.verification}
                          onChange={handleLogin}
                          ref={inputCodeRef}
                          required
                        />
                        <label htmlFor="verification">Ingrese Código</label>
                      </div>}

                      {!nameForm && <div className='forgot-pass'>
                        <span>Enviaremos a tu correo indicaciones para recuperar tu contraseña.</span>
                      </div>}

                      <div className="d-grid gap-2 col-12 mx-auto pt-2">
                      {sending ? <button class="btn btn-primary btn-sm" type="button" disabled>
                          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                          Enviando...
                        </button>:
                        <button onClick={handleSubmit} className="btn btn-lg btn-primary" type="submit">
                        {nameForm ? 'Ingresar' : 'Enviar'}
                        </button>}
                      </div>

                      <div className="d-flex pt-2 login-options">
                        <NavLink className="nav-link" onClick={() => setNameForm(!nameForm)} to={routes.login}>
                          {nameForm ? 'Olvidé mi contraseña': 'Iniciar Sesión'}
                        </NavLink>
                        <a className="nav-link" href="#emailModal" role="button" data-bs-toggle="modal">
                          No tengo cuenta
                        </a>
                      </div>
                      
                      <div id="emailModal" className="modal fade" tabIndex="-1">
                        <div className="modal-dialog">
                          <div className='modal-content font-mulish'>
                            <EmailModal />
                          </div>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
    </div>
  );
})

export default Login
